/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import Arrow from '../../../assets/icons/ArrowCircleLeft.png'

import { Container } from '../../../styles/GlobalStyles'
import { FromMain } from '../ForgetPassword/styles'
import buttonImg from '../../../assets/bgs/Rectangle 9.png'
import Logo from '../../../assets/logos/imglogo.png'
import { version } from '../../../db/data'
import { Link } from 'react-router-dom'
import api from '../../../services/axios'

export default function ResetPassword() {
  const [password, setPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')
  const [token, setToken] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const url = new URL(window.location.href)
    const tokenFromUrl = url.searchParams.get('token') || ''
    setToken(tokenFromUrl)
    setLoading(false)
  }, [])

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!password || !passwordConfirm) {
      toast.error('Preencha os dois campos')
      return
    }
    if (password !== passwordConfirm) {
      toast.error('As senhas não coincidem')
      return
    }
    if (!token) {
      toast.error('Token inválido')
      return
    }

    setLoading(true)

    try {
      const response = await api.post('/auth/reset-password', { token, password })

      if (!response) {
        toast.error('Erro ao redefinir a senha')
      } else {
        toast.success('Senha atualizada com sucesso!')
        setTimeout(() => {
          window.location.href = '/login'
        }, 2000)
      }
    } catch (error) {
      toast.error('Erro na comunicação com o servidor')
    }

    setLoading(false)
  }

  if (loading) return <p className='text-center mt-4'>Carregando...</p>

  return (
    <Container>
      <FromMain onSubmit={handleResetPassword}>
        <p className='back-arrow'>
          <Link to='/login' style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={Arrow} alt='voltar' />
            Voltar
          </Link>
        </p>
        <h3 className='text-2xl font-bold mb-4'>Redefinir senha</h3>

        <input
          type='password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder='Nova senha'
          required
          className='w-full border rounded-lg p-2 mb-4 focus:ring focus:ring-blue-400'
        />
        <input
          type='password'
          value={passwordConfirm}
          onChange={(e) => setPasswordConfirm(e.target.value)}
          placeholder='Confirmar nova senha'
          required
          className='w-full border rounded-lg p-2 mb-4 focus:ring focus:ring-blue-400'
        />

        <button type='submit' disabled={loading}>
          <img src={buttonImg} width='100%' alt='Botão entrar' />
          <p className='btn-text'> {loading ? 'Atualizando...' : 'Salvar nova senha'}</p>
        </button>

        <div className='logo-footer'>
          <img src={Logo} alt='Logo' />
          <span>{version}</span>
        </div>
      </FromMain>
    </Container>
  )
}
